module.exports = __webpack_public_path__ + "img/cny.c40591ea.svg";